import React from 'react';
import { useSelector } from 'react-redux';
import { Visibility } from '@material-ui/icons';
import moment from 'moment';

import { useWindowSize } from '../../../../../../../../common/functions/utils';
import notificationEventType from '../../../../../../../../config/data/notificationTypes';

import styles from './TableComponents.module.css';


export const TActivityEvent = (props) => {

    const { width } = useWindowSize();

    const setting = useSelector(({ generalSetting }) => generalSetting && generalSetting.setting);
    const rentals = useSelector(({ rentals }) => rentals && rentals.rentals);

    const dateTimeFormattedDesktop = moment(props.row['createdAt']).format('YYYY/MM/DD');
    const dateTimeFormattedMobile = moment(props.row['createdAt']).format('DD MMM YYYY hh:mm a');

    const getRentalNameById = (rentalId) => {
        let rentalName = [
            notificationEventType.RENTAL_NOT_FOUND_TO_CREATE_RESERVATION,
            notificationEventType.RENTAL_NOT_FOUND_TO_UPDATE_RESERVATION,
            notificationEventType.RENTAL_NOT_FOUND_TO_REQUEST_RESERVATION,
            notificationEventType.RENTAL_NOT_FOUND_TO_DELETE_RESERVATION
        ].includes(props.row.type) ? "N/A" : (rentals.find(rental => rental.id === rentalId)?.name || "N/A");
        return rentalName;
    };

    return (
        <div 
            className={styles.activityEventContainer}
            onClick={() => {
                if (width < 460) {
                    props.handleView(props.row);
                };
            }}
        >
            {props.field.key === 'message' && (
                <div className={`${styles.activityEvent} col-12`}>
                    <p className='m-0 p-0'>
                        {props.row.message}
                    </p>
                    {props.row?.bookingData &&
                        <p className='m-0 p-0' style={{color: 'gray'}}>
                            Rental: {getRentalNameById(props.row.bookingData[0]?.rentalId)}
                        </p>
                    }
                    <p className={styles.dateTimeMobile}>
                        {dateTimeFormattedMobile}
                    </p>
                </div>
            )}
            {props.field.key === 'createdAt' && (
                <p className={styles.dateTimeDesktop}>
                    {dateTimeFormattedDesktop}
                </p>
            )}
        </div>
    );
};


export const TActionButtons = (props) => {

    return (
        <div className={styles.actionButtons}>
            <Visibility
                className={styles.viewIcon}
                onClick={() => props.handleView(props.row)}
            />
        </div>
    );
};